export const skillsGroups = [
	{
		title: "Frontend",
		skills: [  
		{ name: "React", icon: "devicon-react-original colored", url: "https://reactjs.org/" },
		{ name: "Angular", icon: "devicon-angularjs-plain colored", url: "https://angularjs.org/" },
		{ name: "Vue", icon: "", url: "https://vuejs.org/" },
		{ name: "React Redux", icon: "devicon-redux-original colored", url: "https://react-redux.js.org/" },
		{ name: "NgRx", icon: "", url: "https://ngrx.io/" },
		{ name: "Material UI", icon: "devicon-materialui-plain colored", url: "https://mui.com/" },
		{ name: "Bootstrap", icon: "devicon-bootstrap-plain colored", url: "https://getbootstrap.com/" },
		{ name: "Angular Material", icon: "", url: "https://material.angular.io/" },
		{ name: "EJS", icon: "", url: "https://ejs.co/" },
		{ name: "Twig", icon: "", url: "https://twig.symfony.com/" },
		{ name: "Next.js", icon: "devicon-nextjs-plain-wordmark colored", url: "https://nextjs.org/" },
		{ name: "HTML5", icon: "devicon-html5-plain colored", url: "https://developer.mozilla.org/en-US/docs/Glossary/HTML5" },
		{ name: "CSS", icon: "devicon-css3-plain colored", url: "https://developer.mozilla.org/en-US/docs/Web/CSS" },
		{ name: "SASS", icon: "devicon-sass-original colored", url: "https://sass-lang.com/" },
		{ name: "Javascript", icon: "devicon-javascript-plain colored", url: "https://developer.mozilla.org/en-US/docs/Web/JavaScript" },
		{ name: "Typescript", icon: "devicon-typescript-plain colored", url: "https://www.typescriptlang.org/" },
		{ name: "JQuery", icon: "devicon-jquery-plain colored", url: "https://jquery.com/" }
		]
	},
	{
		title: "Backend",
		skills: [
		{ name: "Spring Boot", icon: "devicon-spring-plain colored", url: "https://spring.io/projects/spring-boot" },
		{ name: "ASP.NET Core", icon: "devicon-dotnetcore-plain colored", url: "https://dotnet.microsoft.com/en-us/learn/aspnet/what-is-aspnet-core" },
		{ name: "Express.js", icon: "devicon-express-original colored", url: "https://expressjs.com/" },
		{ name: "Ruby On Rails", icon: "devicon-rails-plain-wordmark colored", url: "https://rubyonrails.org/" },
		{ name: "Docker", icon: "devicon-docker-plain colored", url: "https://www.docker.com/" },
		{ name: "Kubernetes", icon: "devicon-kubernetes-plain colored", url: "https://kubernetes.io/" },
		{ name: "Docker Compose", icon: "", url: "https://docs.docker.com/compose/" },
		{ name: "Spring Data JPA", icon: "", url: "https://spring.io/projects/spring-data-jpa" },
		{ name: "Entity Framework", icon: "", url: "https://docs.microsoft.com/en-us/ef/" },
		{ name: "Mongoose", icon: "", url: "https://mongoosejs.com/" },
		{ name: "GraphQL", icon: "devicon-graphql-plain colored", url: "https://graphql.org/" },
		{ name: "Lombok", icon: "", url: "https://projectlombok.org/" },
		{ name: "Jest", icon: "devicon-jest-plain colored", url: "https://jestjs.io/" },
		{ name: "JUnit", icon: "", url: "https://junit.org/junit5/" },
		{ name: "Java", icon: "devicon-java-plain colored", url: "https://www.java.com/en/" },
		{ name: "C#", icon: "devicon-csharp-plain colored", url: "https://docs.microsoft.com/en-us/dotnet/csharp/" },
		{ name: "Node.js", icon: "devicon-nodejs-plain colored", url: "https://nodejs.org/en/" },
		{ name: "Python", icon: "devicon-python-plain colored", url: "https://www.python.org/" },
		{ name: "Ruby", icon: "devicon-ruby-plain colored", url: "https://www.ruby-lang.org/en/" },
		{ name: "PHP", icon: "devicon-php-plain colored", url: "https://www.php.net/" }
		]
	},
	{
		title: "Databases",
		skills: [
		{ name: "PostgreSQL", icon: "devicon-postgresql-plain colored", url: "https://www.postgresql.org/" },
		{ name: "MySQL", icon: "devicon-mysql-plain colored", url: "https://www.mysql.com/" },
		{ name: "SQL Server", icon: "", url: "https://www.microsoft.com/en-us/sql-server" },
		{ name: "Oracle Database", icon: "devicon-oracle-plain colored", url: "https://www.oracle.com/database/" },
		{ name: "MongoDB", icon: "devicon-mongodb-plain colored", url: "https://www.mongodb.com/" },
		{ name: "Redis", icon: "devicon-redis-plain colored", url: "https://redis.io/" },
		{ name: "SQLite", icon: "", url: "https://www.sqlite.org/" },
		]
	},
	{
		title: "Tools",
		skills: [
		{ name: "Azure", icon: "devicon-azure-plain colored", url: "https://azure.microsoft.com/" },
		{ name: "AWS", icon: "devicon-amazonwebservices-plain-wordmark colored", url: "https://aws.amazon.com/" },
		{ name: "Jira", icon: "devicon-jira-plain colored", url: "https://www.atlassian.com/software/jira" },
		{ name: "Confluence", icon: "devicon-confluence-plain colored", url: "https://www.atlassian.com/software/confluence" },
		{ name: "GitHub", icon: "devicon-github-original colored", url: "https://github.com/" },
		{ name: "GitLab", icon: "", url: "https://about.gitlab.com/" },
		{ name: "Postman", icon: "", url: "https://www.postman.com/" },
		{ name: "Insomnia", icon: "devicon-insomnia-plain colored", url: "https://insomnia.rest/" },
		{ name: "Swagger", icon: "", url: "https://swagger.io/" },
		{ name: "Figma", icon: "", url: "https://www.figma.com/" },
		{ name: "Diagrams.net", icon: "", url: "https://www.diagrams.net/" },
		{ name: "MongoDB Atlas", icon: "", url: "https://www.mongodb.com/atlas" },
		{ name: "VS Code", icon: "devicon-vscode-plain colored", url: "https://code.visualstudio.com/" },
		{ name: "Visual Studio", icon: "devicon-visualstudio-plain colored", url: "https://visualstudio.microsoft.com/" },
		{ name: "IntelliJ IDEA", icon: "", url: "https://www.jetbrains.com/idea/" },
		]
	},
	{
		title: "AI",
		skills: [
		{ name: "Github Copilot", icon: "", url: "https://github.com/copilot" },
		{ name: "Claude", icon: "", url: "https://claude.ai/" },
		{ name: "ChatGPT", icon: "", url: "https://openai.com/chatgpt" },
		{ name: "Gemini", icon: "", url: "https://gemini.google.com/" }
		]
	}
];